class PlayerHeaderContent {
  constructor(container) {
    this.container = container;
    this.nameElement = container.querySelector('[data-player-header-name]');
    this.bioElement = container.querySelector('[data-player-header-bio]');
    this.playersElement = container.querySelector('[data-player-header-players]');
    this.readMoreButton = container.querySelector('[data-player-header-read-more]');
    this.resizeObserver = null;
  }

  init() {
    if (this.container.dataset.playerHeaderInitialized === 'true') return;

    // Liquid cannot reliably read the player query parameter, so hydrate from embedded player data.
    const playerHandle = new URLSearchParams(window.location.search).get('player');
    const player = this.getPlayers().find(({ handle }) => handle === playerHandle);

    this.container.dataset.playerHeaderInitialized = 'true';

    if (player) {
      this.updateName(player.name);
      this.updateBio(player.bio);
    }

    this.initReadMore();
  }

  getPlayers() {
    if (!this.playersElement) return [];

    try {
      return JSON.parse(this.playersElement.textContent) || [];
    } catch (error) {
      console.error('PlayerHeaderContent: unable to parse player data', error);
      return [];
    }
  }

  updateName(name) {
    if (!this.nameElement || !name) return;

    this.nameElement.textContent = name;
    this.nameElement.hidden = false;
  }

  updateBio(bio) {
    if (!this.bioElement || !bio) return;

    this.bioElement.innerHTML = bio;
    this.bioElement.hidden = false;
  }

  initReadMore() {
    if (
      !this.bioElement
      || !this.readMoreButton
      || this.container.dataset.truncateText !== 'true'
    ) return;

    // Only show the control when the configured line clamp is actually clipping the biography.
    const updateReadMoreVisibility = () => {
      if (this.container.classList.contains('active')) return;

      this.readMoreButton.hidden = this.bioElement.scrollHeight <= this.bioElement.clientHeight;
    };

    requestAnimationFrame(updateReadMoreVisibility);

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(updateReadMoreVisibility);
      this.resizeObserver.observe(this.bioElement);
    }
  }
}

export const initPlayerHeaderContent = () => {
  document.querySelectorAll('[data-player-header-content]').forEach((container) => {
    new PlayerHeaderContent(container).init();
  });
};

initPlayerHeaderContent();
